export default {
  firstName: "First name",
  lastName: "Last name",
  male: "Male",
  female: "Female",
  favoriteColor: "Favorite color",
  employed: "Employed",
  notes: "Notes",
  email: 'Email address',
  password: 'Password',
  oldPassword: 'Current password',
  newPassword: 'New password',
  confirmPassword: 'Confirm password',
  confirmNewPassword: 'Confirm new password',
  rememberMe: 'Remember me',
  keywords: 'Keywords',
  validation: {
    emailRequired: 'An email address is required.',
    passwordsMustMatch: 'Entered passwords must match.',
  },

  newsletter: {
    email: 'Email address',
    schoolLevels: 'School level',
    submit: 'Subscribe',
  },
};



// WEBPACK FOOTER //
// ./src/config/locales/en/form.js